/* eslint-disable comma-dangle, no-var */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

/* Free implementation of getUserInput. This should be used sparingly, since it
 * just returns all the widget's props rather than picking out those which were
 * input by the user.
 */
var WIDGET_PROP_BLACKLIST = require("./widget-prop-blacklist.jsx");
var _ = require("underscore");

var WidgetJsonifyDeprecated = {
    getUserInput: function getUserInput() {
        // Omit props that get passed to all widgets
        return _.omit(this.props, WIDGET_PROP_BLACKLIST);
    }
};

module.exports = WidgetJsonifyDeprecated;


/*****************
 ** WEBPACK FOOTER
 ** ./src/mixins/widget-jsonify-deprecated.jsx
 ** module id = 242
 ** module chunks = 0 2
 **/